import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs } from 'ws-scripts/modules/common';

import { isPrefValueEnabled } from '../utils/prefUtils';
import NavItemList from './NavItemList';
import PanelHeader from './PanelHeader';
import SearchFieldButton from './SearchFieldButton';
import DrawerCTAButtons from './DrawerCTAButtons';
import DealerContactSection from './DealerContactSection';

/**
 * DrawerPanelBody — main drawer content panel.
 * Renders the header, search trigger, nav item list, and CTA buttons.
 * The drilldown submenu is rendered as a separate Modal by
 * NavigationDrawer, not inside this component.
 *
 * @param {DrawerPanelBodyProps} props
 * @param {string} [props.title] - Heading text for the drawer header
 * @param {ElementRef} [props.closeRef] - Ref forwarded to the close button element
 * @param {ObjectElementRef} [props.searchRef] - Ref forwarded to the search trigger button element
 */
const DrawerPanelBody = ({ title = '', closeRef = null, searchRef = null }) => {
	const { enableSiteWideSearch } = usePrefs();

	const showSearch = isPrefValueEnabled(enableSiteWideSearch);

	return (
		<div
			className="ws-nav-drawer__main-content d-flex flex-column flex-grow-1 overflow-auto"
			data-testid="drawer-main-content"
		>
			<div
				className="ws-nav-drawer__panel-header-outer py-4"
				data-testid="drawer-panel-header-outer"
			>
				<PanelHeader title={title} closeRef={closeRef} />
			</div>
			<div
				className="ws-nav-drawer__body d-flex flex-column flex-grow-1"
				data-testid="drawer-body"
			>
				{showSearch && <SearchFieldButton searchRef={searchRef} />}
				<NavItemList />
				<DrawerCTAButtons />
				<DealerContactSection />
			</div>
		</div>
	);
};

DrawerPanelBody.propTypes = {
	title: PropTypes.string,
	closeRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
	searchRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) })
};

export default DrawerPanelBody;
